import { useState } from "react";
import Column from "@amzn/meridian/esm/components/column";
import LogManager from "../../utils/logManager";
import { FEEDBACK, BUILT_IN_AGENT } from "../../constants";
import FeedbackButtons from "../../components/feedback/FeedbackButtons";
import { FEEDBACK_TYPE } from "../../components/feedback/feedback.constants";

const InMeetingExpFeedback = ({
  agent,
  sessionId,
  aimsUuid,
  messageTimestamp,
  promptType,
  userInput,
  agentResponse,
  extensionId,
  meetingId,
  meetingUuid,
  onFeedbackMessage,
  onOpenFeedbackPopover,
  streamingDisabled,
}) => {
  const [feedback, setFeedback] = useState(undefined);
  const [isFeedbackDisabled, setIsFeedbackDisabled] = useState(false);

  const submitFeedbackToApi = async (feedbackValue, comment) => {
    const requestBody = {
      type: FEEDBACK_TYPE.IN_MEETING_EXP,
      sessionId,
      aimsUuid: aimsUuid || "",
      messageTimestamp,
      feedback: feedbackValue,
      feedbackTimestamp: Math.floor(Date.now() / 1000),
      promptType,
      userInput: userInput?.substring(0, 2000) || "",
      agentResponse: agentResponse?.substring(0, 10000) || "",
      extensionId: extensionId || BUILT_IN_AGENT.id,
      zoomMeetingId: meetingId || "",
      meetingUuid: meetingUuid || "",
      feedbackComment: comment || undefined,
    };
    LogManager.info("Calling /feedback with type \"inMeetingExp\". Request body is: " + JSON.stringify(requestBody));

    try {
      const response = await fetch("/feedback", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(requestBody),
      });
      if (!response.ok) {
        throw new Error(`Feedback request failed with status ${response.status}`);
      }
      const responseJson = await response.json();
      LogManager.info("The responseJson of /feedback (inMeetingExp) is: " + JSON.stringify(responseJson));
    } catch (error) {
      LogManager.error("Error submitting in-meeting feedback:", error);
      setIsFeedbackDisabled(false);
      setFeedback(undefined);
    }
  };

  const handleThumbsUp = async () => {
    if (isFeedbackDisabled) return;
    setIsFeedbackDisabled(true);
    setFeedback(FEEDBACK.THUMBS_UP);
    if (onFeedbackMessage) {
      onFeedbackMessage("Thanks for your feedback! 👍", agent);
    }
    await submitFeedbackToApi(FEEDBACK.THUMBS_UP, null);
  };

  const handleThumbsDown = () => {
    if (isFeedbackDisabled) return;
    setFeedback(FEEDBACK.THUMBS_DOWN);
    setIsFeedbackDisabled(true);
    if (onFeedbackMessage) {
      onFeedbackMessage("Thanks for your feedback. We'll work on making this better.", agent);
    }
    if (onOpenFeedbackPopover) {
      onOpenFeedbackPopover(async (comment) => {
        await submitFeedbackToApi(FEEDBACK.THUMBS_DOWN, comment);
      });
    }
  };

  return (
    <Column spacing="none">
      <FeedbackButtons
        feedback={feedback}
        disabled={isFeedbackDisabled || streamingDisabled}
        onThumbsUp={handleThumbsUp}
        onThumbsDown={handleThumbsDown}
      />
    </Column>
  );
};

export default InMeetingExpFeedback;
